import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Shield } from "lucide-react";
import { Container } from "@/components/common/ui";
import { FEATURED_TESTIMONIAL_IDS, TESTIMONIALS } from "@/lib/testimonials";

const FEATURED = FEATURED_TESTIMONIAL_IDS.map((id) => TESTIMONIALS.find((t) => t.id === id));

export const TestimonialCarousel = () => {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const t = FEATURED[i];
  useEffect(() => {
    if (paused) return undefined;
    const id = setInterval(() => setI((x) => (x + 1) % FEATURED.length), 9000);
    return () => clearInterval(id);
  }, [paused]);
  const go = (d) => setI((x) => (x + d + FEATURED.length) % FEATURED.length);

  return (
    <section className="bg-mist py-20 sm:py-24" data-testid="testimonials" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <Container className="max-w-[980px]">
        <p className="eyebrow text-center">Virginia Beach & Greater Richmond real estate specialists</p>
        <figure key={t.id} className="mt-8 animate-rise-in text-center" data-testid="testimonial-active">
          <blockquote className="font-display text-xl italic leading-relaxed text-ink sm:text-[26px] sm:leading-[1.5]">
            “{t.text.length > 420 ? `${t.text.slice(0, 420).replace(/\s+\S*$/, "")}…` : t.text}”
          </blockquote>
          <figcaption className="mt-6 flex items-center justify-center gap-3 text-[15px] text-neutral-700">
            <span className="font-medium text-ink">{t.name}</span>
            {t.military && (
              <span className="inline-flex items-center gap-1 rounded-full bg-ink px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest text-brass">
                <Shield className="h-3 w-3" /> Military family
              </span>
            )}
          </figcaption>
        </figure>
        <div className="mt-10 flex items-center justify-center gap-5">
          <button onClick={() => go(-1)} aria-label="Previous review" data-testid="testimonial-prev" className="grid h-10 w-10 place-items-center rounded-full border border-neutral-300 hover:border-ink">
            <ChevronLeft className="h-4 w-4" />
          </button>
          <div className="flex gap-2">
            {FEATURED.map((f, n) => (
              <button key={f.id} onClick={() => setI(n)} aria-label={`Review ${n + 1}`} data-testid={`testimonial-dot-${n}`}
                className={`h-1.5 rounded-full transition-all ${n === i ? "w-8 bg-ink" : "w-1.5 bg-neutral-300"}`} />
            ))}
          </div>
          <button onClick={() => go(1)} aria-label="Next review" data-testid="testimonial-next" className="grid h-10 w-10 place-items-center rounded-full border border-neutral-300 hover:border-ink">
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
        <p className="mt-10 text-center text-[15px] text-neutral-600">
          We've helped more than 2000 Virginia Beach & Greater Richmond area families just like yours.
        </p>
      </Container>
    </section>
  );
};
